import { message } from 'antd';
import { put, takeLatest, select } from 'redux-saga/effects';
import { RootState } from 'data';
import { StoreActionProps } from 'data/core';
import { logger } from 'services';
import {
  updatePhaseInProjectTemplate,
  UpdatePhaseInProjectTemplatePayload,
} from '../../actions';
import {
  updateProjectTemplateProjectPhase,
  updateProjectTemplateTask,
} from '../../slices';
import { ProjectTemplateProjectPhase } from '../../types';
import { setupProjectPhaseRelatedEntity } from './create';

const selectProjectPhase =
  (id: number) =>
  ({ templates }: RootState): ProjectTemplateProjectPhase =>
    templates.project.data[templates.project.activeId].projectPhases[id];

function* updateProjectPhaseInTemplateSaga(
  action: StoreActionProps<UpdatePhaseInProjectTemplatePayload>,
) {
  try {
    const {
      payload: { projectPhaseId, payload, handleSuccess },
    } = action;

    const isNewProjectPhase = payload.isNew;

    const phase: ProjectTemplateProjectPhase = yield select(
      selectProjectPhase(projectPhaseId),
    );

    yield put(
      updateProjectTemplateProjectPhase({
        projectPhase: { ...phase, ...payload, isNew: false },
        updatePrivacyOfChildren: payload.private != null,
      }),
    );

    if (payload.startDay) {
      yield put(
        updateProjectTemplateTask({
          task: {
            taskId: phase.tasks[phase.tasks.length - 1] as unknown as number,
            startDay: payload.startDay,
          },
          isNew: true,
        }),
      );
    }

    if (isNewProjectPhase) {
      yield setupProjectPhaseRelatedEntity(
        projectPhaseId,
        payload.projectPhaseName,
      );
    }

    if (handleSuccess) {
      handleSuccess();
    }
  } catch (error) {
    logger.error('Error in updating the project phase', { error });

    message.error('There was an error updating the project phase');
  }
}

export function* watchUpdatePhaseInProjectTemplateSaga(): Generator {
  yield takeLatest(
    updatePhaseInProjectTemplate.type,
    updateProjectPhaseInTemplateSaga,
  );
}
